import {
  GET_CONFIG,
  GET_CONFIG_SUCCESS,
  GET_CONFIG_FAILURE,
  GET_CONFIG_SYS,
  GET_CONFIG_SYS_SUCCESS,
  GET_CONFIG_SYS_FAILURE,
  GET_CONFIG_SYS_LOAI_TAI_SAN,
  GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS,
  GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE,
} from "./actionTypes";

export const getConfig = (dataSearch) => ({
  type: GET_CONFIG,
  dataSearch,
});

export const getConfigSuccess = (data) => ({
  type: GET_CONFIG_SUCCESS,
  payload: data,
});

export const getConfigFailure = () => ({
  type: GET_CONFIG_FAILURE,
});

export const getConfigSys = () => ({
  type: GET_CONFIG_SYS,
});

export const getConfigSysSuccess = (data) => ({
  type: GET_CONFIG_SYS_SUCCESS,
  payload: data,
});

export const getConfigSysFailure = () => ({
  type: GET_CONFIG_SYS_FAILURE,
});

export const getConfigSy_LoaiTaiSan = (dataSearch) => ({
  type: GET_CONFIG_SYS_LOAI_TAI_SAN,
  dataSearch,
});

export const getConfigSy_LoaiTaiSanSuccess = (data) => ({
  type: GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS,
  payload: data,
});

export const getConfigSy_LoaiTaiSanFailure = () => ({
  type: GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE,
});
